import styled from "styled-components";

export const RadioFieldContainer = styled.div`
  display: inline-flex;
  position: relative;
  padding-left: 25px;
  align-items: center;
  gap: 5px;
  /* margin-bottom: 12px; */
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  user-select: none;
  color: inherit;
  &.responsive {
    font-size: clamp(12px, 0.833vw, 16px);
    padding-left: clamp(22px, 1.302vw, 25px);
    .radio-checkmark {
      height: clamp(15px, 0.885vw, 17px);
      width: clamp(15px, 0.885vw, 17px);
    }
    .radio-checkmark:after {
      top: 2px;
      left: 2px;
      width: clamp(9px, 0.573vw, 11px);
      height: clamp(9px, 0.573vw, 11px);
      border-radius: 50%;
      background: #0a5587;
    }
  }
  /* margin-top: 4px; */
  .radio-container {
    font-family: "latosemibold";
    line-height: 26px;
    display: inline-flex;
    align-items: flex-start;
    .i-icon-btn {
      margin-top: 5px;
      cursor: pointer;
    }
  }
  /* Create a custom radio button */
  input:checked ~ .radio-checkmark:after {
    display: block;
  }
  .radio-checkmark {
    position: absolute;
    top: 5px;
    left: 0;
    height: 17px;
    width: 17px;
    background-color: transparent;
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid #0a5587;
    &.true {
      background-color: gray;
      :hover {
        background-color: gray;
      }
    }
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* On mouse-over, add a grey background color */
  .radio-container:hover input ~ .radio-checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  input:checked ~ .radio-checkmark {
    background-color: transparent;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .radio-checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #0a5587;
  }
  .radio-checkmarkDisabled:after {
    top: 2px;
    left: 2px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: gray;
  }
  .radio-postingRadioDisable:after {
    top: 2px;
    left: 2px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: gray;
  }
`;
